module.exports = __webpack_public_path__ + "img/MLW_III.649c02ff.svg";